import { render } from "./MainPageContainer.vue?vue&type=template&id=3b9bf802&scoped=true"
import script from "./MainPageContainer.vue?vue&type=script&lang=js"
export * from "./MainPageContainer.vue?vue&type=script&lang=js"

import "./MainPageContainer.vue?vue&type=style&index=0&id=3b9bf802&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b9bf802"]])

export default __exports__